import { FaRegPlayCircle, FaRegFile, FaCheckDouble } from 'react-icons/fa'

export default {
  video: FaRegPlayCircle,
  document: FaRegFile,
  exam: FaCheckDouble,
}
